import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function spainRekycValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control?.value) {
            return { spainRekycLimit: true };
        }
        return null;
    };
}
//spain occupational details message validators
export function spainODValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control?.value) {
            return { spainOdInlineVal: true };
        }
        return null;
    };
}

//spain aml threshold to be exceeded validator
export function amlThresholdToBeExcValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control?.value) {
            return { spainThreshLimitToBeBreached: true };
        }
        return null;
    };
}

//spain aml threshold exceeded validator
export function amlThresholdExcValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control?.value) {
            return { spainThreshLimitBreached: true };
        }
        return null;
    };
}

//spain annual rekyc limit exceeded validator
export function annRekycLimitExcValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control?.value) {
            return { spainAnnRekycLimitExceeded: true };
        }
        return null;
    };
}
export function ExpiredKycLimitValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control?.value) {
            return { expiredKycLimitValidation: true };
        }
        return null;
    };
}
